import { Session, SessionToken } from '@standardnotes/domain-core';
export class SessionStorageMapper {
    toDomain(projection) {
        const accessTokenOrError = SessionToken.create(projection.accessToken, projection.accessExpiration);
        if (accessTokenOrError.isFailed()) {
            throw new Error(accessTokenOrError.getError());
        }
        const accessToken = accessTokenOrError.getValue();
        const refreshTokenOrError = SessionToken.create(projection.refreshToken, projection.refreshExpiration);
        if (refreshTokenOrError.isFailed()) {
            throw new Error(refreshTokenOrError.getError());
        }
        const refreshToken = refreshTokenOrError.getValue();
        const session = Session.create(accessToken, refreshToken, projection.readonlyAccess);
        if (session.isFailed()) {
            throw new Error(session.getError());
        }
        return session.getValue();
    }
    toProjection(domain) {
        return {
            accessToken: domain.accessToken.value,
            refreshToken: domain.refreshToken.value,
            accessExpiration: domain.accessToken.expiresAt,
            refreshExpiration: domain.refreshToken.expiresAt,
            readonlyAccess: domain.isReadOnly(),
        };
    }
}
